export const EXCHANGE_RATE = {
    HK: 1,
    RMB: 1.1,
    US: 7.8,
    GBP: 10,
    EUR: 8.7,
    CAD: 5.9,
    AUD: 5.4,
    JPY: 0.07,
}

export const CURRENCY_SIGN = {
    HK: 'HKD',
    RMB: 'RMB',
    US: 'USD',
    GBP: 'GBP',
    EUR: 'EUR',
    CAD: 'CAD',
    AUD: 'AUD',
    JPY: 'JPY',
}

export function currencySign(currency: string) {
    return CURRENCY_SIGN[currency] || currency || ''
}

export function getExchangeRate(currency: string) {
    const rate = EXCHANGE_RATE[currency]
    return rate || 1
}
